// extracted by mini-css-extract-plugin
export var option = "_kw-0";
export var optionCard = "_kw-f";
export var optionContent = "_kw-g";
export var optionIcon = "_kw-i";
export var optionIconBox = "_kw-h";
export var optionLabel = "_kw-j";
export var optionPill = "_kw-m";
export var optionPillBadge = "_kw-p";
export var optionPillIcon = "_kw-n";
export var optionPillLabel = "_kw-o";
export var optionRadio = "_kw-k";
export var optionRadioInner = "_kw-l";
export var optionReveal = "_kw-2";
export var optionRevealDelay0 = "_kw-3";
export var optionRevealDelay1 = "_kw-4";
export var optionRevealDelay10 = "_kw-d";
export var optionRevealDelay11 = "_kw-e";
export var optionRevealDelay2 = "_kw-5";
export var optionRevealDelay3 = "_kw-6";
export var optionRevealDelay4 = "_kw-7";
export var optionRevealDelay5 = "_kw-8";
export var optionRevealDelay6 = "_kw-9";
export var optionRevealDelay7 = "_kw-a";
export var optionRevealDelay8 = "_kw-b";
export var optionRevealDelay9 = "_kw-c";
export var optionSelected = "_kw-1";